/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';
import { CollectionResult, LineupEntry } from './sessionModels';

const URL = `${process.env.REACT_APP_PORTAL_URL}/api/v1/sessions`;

type FrameRange = { start: number; end: number };

export default {
  getSnapshot(videoId: number | string): Promise<string> {
    return axios.get(`${URL}/videos/${videoId}/snapshot`);
  },
  getDataFrames(sessionId: number | string, lineupEntryId: number): Promise<CollectionResult<FrameRange>> {
    return axios.get(`${URL}/${sessionId}/lineup-entries/${lineupEntryId}/data-frames`);
  },
  async getLineupFrameCount(sessionId: number | string, lineup: LineupEntry[]): Promise<number> {
    const results = await Promise.all(lineup.map((entry) => this.getDataFrames(sessionId, entry.id)));
    return results
      .flatMap((result) => result?.items ?? [])
      .reduce((total, range) => total + range.end - range.start + 1, 0);
  },
};
